import { useQuery } from "react-query";
import { api } from "../utils/api/api";

const getLatestScholarshipId = async () => {
  try {
    const { data } = await api.get(
      `${process.env.REACT_APP_API_URL}tracs_v3/scholarships/Scholarships_unprotected_api/getLatestScholarshipId`
    );
    return data;
  } catch (err) {
    throw new Error(err);
  }
};

export function useScholarshipId() {
  return useQuery("scholarshipId", () => getLatestScholarshipId());
}
